import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { collection, getDocs, where, query } from "firebase/firestore";
import { db } from "../firebaseConfig";
import Button from 'react-bootstrap/Button';
import "../components/PostShow.css"; // Import the CSS file for styling similar to PostShow
import Sidebar from "../components/Sidebar";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function FilteredPosts() {
  const { tag } = useParams();
  const [filteredPosts, setFilteredPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFilteredPosts = async () => {
      const q = query(collection(db, "posts"), where("tags", "array-contains", tag));
      const querySnapshot = await getDocs(q);
      const posts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setFilteredPosts(posts);
    };

    fetchFilteredPosts();
  }, [tag]);

  // Helper function to strip HTML tags and limit the length of the text
  const stripHtmlAndTruncate = (html, limit) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const textContent = tempDiv.textContent || tempDiv.innerText || "";
    const words = textContent.split(" ");
    return words.length > limit ? words.slice(0, limit).join(" ") + "..." : textContent;
  };

  return (
    // <div className="filtered-posts-grid">
   
      
    // </div>

<Container>
<Row>
  <Col sm={8}>   <div className="filtered-posts-main">
        <Button variant="primary" className="back-btn" onClick={() => navigate("/")}>Back to Home</Button>

        <h1>Posts tagged with "{tag}"</h1>
        {filteredPosts.length === 0 && <p>No posts found for this tag.</p>}

        <div className="posts">
          {filteredPosts.map(post => (
            <div key={post.id} className="post">
              <h2>
                <Link to={`/post/${post.id}`}>{post.title}</Link>
              </h2>
              {post.imageUrl && <img src={post.imageUrl} alt={post.title} className="post-image" />}
              <div className="post-content">
                <div dangerouslySetInnerHTML={{ __html: stripHtmlAndTruncate(post.content, 30) }} />
              </div>
              <p><strong>Author:</strong> {post.author}</p>
              <p>
                <strong>Tags:</strong>{" "}
                {post.tags ? (
                  post.tags.map((tag, index) => (
                    <span key={index}>
                      <Link to={`/tags/${tag}`}>{tag}</Link>
                      {index !== post.tags.length - 1 && ", "}
                    </span>
                  ))
                ) : (
                  "No tags"
                )}
              </p>
              <div className="read-more-button">
                <Link to={`/post/${post.id}`}>
                  <Button variant="primary">Read More</Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
</Col>
  <Col sm={4}><Sidebar /></Col>
</Row>

</Container>

  );
}

export default FilteredPosts;
